import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import * as Api from 'web-app/react/entities/bill-payers/api';
import * as ChildActions from 'web-app/react/entities/children/actions';

import * as Actions from './actions';

const searchForBillPayer = action$ =>
    action$
        .ofType(Actions.search.type)
        .debounceTime(500)
        .mergeMap(({payload}) => {
            return Api.searchBillPayer(payload.institutionId, payload.childId, payload.term, payload.billPayerType)
                .flatMap(({billPayers, children}) => [
                    ChildActions.fetchAllSuccess.action(children),
                    Actions.searchSuccess.action({billPayers}),
                ])
                .catch(e => Observable.of(Actions.searchFailed.action(e)));
        });

export default combineEpics(searchForBillPayer);
